export const createSetter = (name, defaultValue) => (state, value = defaultValue) => {
  state[name] = value
}

export const createGetter = (name) => (state) => state[name]
